/** @format */

import React from "react";
import GallerySection from "./landing/GallerySection";
import Subtitle from "./landing/Subtitle";
import Title from "./landing/Title";

const Gallery = () => {
  return (
    <div className="pt-[91px]" id="gallery">
      <div className="flex flex-col justify-center items-center">
        <Title title="OUR GALLERY" titleClass="title-text" />
        <Subtitle summary="See how other users are getting in shape by working out at home" />
      </div>
      <GallerySection />
    </div>
  );
};

export default Gallery;
